import { handleOpenChat } from '@/helpers';
import { BlockStack, Box, Button, Card, Link, Text } from '@shopify/polaris';
import CollapsibleSection from './components/CollapsibleSection';

const sections = [
  {
    title: 'How does recurring subscription work?',
    content: (
      <Text as="p">
        We follow{' '}
        <Link
          external
          monochrome
          url="https://help.shopify.com/en/manual/your-account/manage-billing/billing-charges/types-of-charges/third-party-charges/app-charges#subscriptions"
        >
          Shopify’s guidelines for Recurring pricing plans
        </Link>{' '}
        to ensure a smooth and compliant subscription experience.
      </Text>
    ),
  },
  {
    title: 'How does quota-based pricing work?',
    content: (
      <Text as="p">
        1 quota is equal to 1 synced and tracked order. Even with multiple shipments, an order still counts as 1 quota. Each plan
        comes with a base number of monthly orders. You can increase this quota using the slider to accommodate your business
        needs. The price adjusts automatically as you increase the quota.
      </Text>
    ),
  },
  {
    title: 'What happens if I exceed my monthly order quota?',
    content: (
      <Text as="p">
        If you exceed your chosen quota, we'll automatically suspend syncing order status of those orders. If you consistently
        exceed your quota, we'll suggest upgrading to a more suitable plan.
      </Text>
    ),
  },
];

function QnASection() {
  return (
    <Box>
      <Box paddingBlockEnd="200">
        <Text as="p" variant="headingLg">
          Frequently asked questions
        </Text>
      </Box>
      <Card>
        <BlockStack gap="300">
          {sections.map((section, index) => (
            <CollapsibleSection key={index} content={section.content} title={section.title} index={index} />
          ))}
          <Text as="span">
            <Button onClick={handleOpenChat} variant="plain" removeUnderline>
              Concern about pricing plan? Contact us
            </Button>
          </Text>
        </BlockStack>
      </Card>
    </Box>
  );
}

export default QnASection;
